export const VIDFLEET_CLIP_REQUESTS_DETAILS_OPEN_MODAL = "VIDFLEET_CLIP_REQUESTS_DETAILS_OPEN_MODAL";
export const VIDFLEET_CLIP_REQUESTS_DETAILS_REQUEST = "VIDFLEET_CLIP_REQUESTS_DETAILS_REQUEST";
export const VIDFLEET_CLIP_REQUESTS_DETAILS_RESULT = "VIDFLEET_CLIP_REQUESTS_DETAILS_RESULT";